import {
    GET_SITE_BACKUP,
    GET_SITE_BACKUP_SUCCESS,
    GET_SITE_BACKUP_FAIL,
} from '../../constants/siteBackup/siteBackupConstants.js';

/**
 * Reducer function for managing site backup list state.
 *
 * This reducer handles actions related to fetching site backup data.
 * It updates the state based on the dispatched action type and payload.
 *
 * @param {object} state - Current state of the site backup list.
 * @param {object} action - Action object that contains information about the action type and payload.
 * @return {object} - New state after applying the action.
 */
export const siteBackupReducer = (state = { siteBackupList: {} }, action) => {
    switch (action.type) {
        case GET_SITE_BACKUP:
            return {
                loading: true,
            };
        case GET_SITE_BACKUP_SUCCESS:
            return {
                loading: false,
                siteBackupList: action.payload,
            };
        case GET_SITE_BACKUP_FAIL:
            return {
                loading: false,
                error: action.payload,
            };
        default:
            return state;
    }
};
